export enum CvrCompanyTypeShort {
  LTD = 'ltd',
  EMV = 'emv',
}
